import merge from 'lodash/merge';

class Config {
    constructor () {
        Object.assign(this, {
            dateFormat: {
                shortDate: 'dd MMM',
                date: 'yyyy/MM/dd',
                time: 'HH:mm',
                dateTime: 'yyyy/MM/dd HH:mm:ss',
            },
            defaultCurrency: 'EUR',
            customizationFilesDimensions: {
                upyield: {
                    logo: '160x40',
                    'logo-small': '40x40',
                    favicon: '128x128',
                },
                publisher: {
                    logo: '208x32',
                    favicon: '128x128',
                },
            },
            pageTitle: 'upyield',
            payoutDefaults: {
                type: 'fixed',
                percentage: 70,
            },
            revenueDefaults: {
                type: 'fixed',
                percentage: 100,
            },
            defaultCapType: 'daily',
            emailTemplates: {
                alwaysActive: [
                    'password:reset_link',
                    'password:reset',
                    'onboarding:accepted',
                    'onboarding:created',
                    'onboarding:rejected',
                ],
                fromEmailRecipient: '{{config.general.notifications_from_email}}',
                fromNameRecipient: '{{config.general.notifications_from_name}}',
            },
            analytics: {
                manualAdjustment: {
                    maxTimeframe: 7,
                },
            },
            defaultListLimit: 20,
        });
    }

    extend (config) {
        merge(this, config);
    }
}

const config = new Config(),
    extend = config.extend;

export default config;
export { extend };
